import React from 'react';
import { Link } from 'react-router-dom';
import { PATIENT_INFORMATION_STATS } from '../dashboardStatsConfig';

function DashboardPatientInformation({ getStat, isLoading, loadError, lastUpdated }) {
    return (
        <section className="ecx-page-card ecx-page-panel dashboard-stats-panel">
            <div className="ecx-page-panel__header">
                <div className="d-flex align-items-center justify-content-between gap-3 flex-wrap">
                    <div className="dashboard-stats-panel__heading">
                        <span className="ecx-page-icon-badge">
                            <i className="bi bi-people-fill" />
                        </span>
                        <div>
                            <h2 className="dashboard-stats-panel__title">Patient Information</h2>
                            <p className="dashboard-stats-panel__subtitle mb-0">
                                {lastUpdated
                                    ? `Coverage and opt-in metrics · Updated ${lastUpdated}`
                                    : 'Coverage and communication opt-in metrics'}
                            </p>
                        </div>
                    </div>
                    <Link to="/patient-files" className="btn btn-sm btn-light-primary rounded-pill">
                        Open patient files
                        <i className="bi bi-arrow-right ms-1" />
                    </Link>
                </div>
            </div>

            <div className="ecx-page-panel__body">
                {loadError && (
                    <div className="dashboard-alert" role="alert">
                        <i className="bi bi-exclamation-circle me-2" />
                        {loadError}
                    </div>
                )}

                {isLoading ? (
                    <div className="dashboard-section-grid">
                        {Array.from({ length: 7 }).map((_, index) => (
                            <div key={`patient-stat-skel-${index}`} className="dashboard-stat-tile dashboard-stat-tile--skeleton" />
                        ))}
                    </div>
                ) : (
                    <div className="dashboard-section-grid">
                        {PATIENT_INFORMATION_STATS.map((stat) => (
                            <div key={stat.key} className="dashboard-stat-tile">
                                <span className="dashboard-stat-tile__label">
                                    <i className={`bi ${stat.icon} me-1`} aria-hidden="true" />
                                    {stat.label}
                                </span>
                                <span className="dashboard-stat-tile__value">{getStat(stat.key)}</span>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </section>
    );
}

export default DashboardPatientInformation;
